export default __webpack_public_path__ + "static/media/deferred-payment.28186ccd.svg";